import styled from 'styled-components';

export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .ant-form {
    width: 100%;
  }

  .ant-btn {
    width: 100%;
  }
`;
